<div
    id="root"
    [class.has-notification-bar]="hasNotificationBar$ | async"
    [class.has-primary-nav]="hasPrimaryNav$ | async"
    [appshell-deactivate-area]="[AppAreaType.SidebarLocalLeft]"
    [priva-toggle-class]="{ contentActions: 'has-content-overlay' }"
    [priva-toggle-deactivate]="['contentActions', 'showPrimaryNavItems']"
>
    <!-- AREA | COMPONENT: Notification messages -->
    <priva-notifications />

    <!-- App Shell main component -->
    <router-outlet />
</div>
